import * as styles from './TromanChip.module.less';
import { Icon, Icons } from "./Buttons";
import React from 'react';

export enum TromanColor {
    Politiker = 'politiker_brand',
    Publik = 'publik_brand',
}

function getChipStyle(color: TromanColor) {
    switch (color) {
        case TromanColor.Politiker: return `${styles.chip} ${styles.politikerBrand}`;
        case TromanColor.Publik: return `${styles.chip} ${styles.publikBrand}`;
    }
}

export interface ITromanChipProps {
    text: string;
    color: TromanColor;
    icon?: Icons;
}
export const TromanChip = (props: ITromanChipProps) => {
    return (
        <span className={getChipStyle(props.color)}>
            { props.icon && <span className={styles.icon}><Icon icon={props.icon}/></span> }
            <span className={styles.text}>{props.text}</span>
        </span>
    )
};
